/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Footer = () => {
  const updatedDate = new Date().getFullYear();
  return (
    <footer className="bg-black bg-[url('../images/all-img/footer-bg-1.png')] bg-cover bg-center bg-no-repeat">
      <div className="container border-t border-white border-opacity-[0.1] py-8 text-center text-base">
        &copy; Copyright {updatedDate} | Vatel France | <a href="https://www.vatel.fr/fr/infos/mentions-legales-et-politique-de-confidentialite" target={"_blank"} rel={"noreferrer"}> Mentions légales</a>
      </div>
    </footer>
  );
};

export default Footer;
